export default __webpack_public_path__ + "static/media/media_rewind_30.ccf5572a.svg";